export const confirmEditProfile = {
  title: 'Внимание',
  content: 'Вы действительно хотите сохранить внесенные изменения?',
  okText: 'Сохранить изменения',
  cancelText: 'Отмена',
  className: 'confirm-red',
  okType: 'primary',
  width: 432,
  cancelButtonProps: {
    type: 'primary',
    ghost: true,
  },
};

export const confirmCloseEditing = {
  title: 'Внимание',
  content:
    'Вы действительно хотите отменить редактирование сотрудника? Данные будут удалены!',
  okText: 'Отменить изменения',
  cancelText: 'Отмена',
  className: 'confirm-red',
  okType: 'danger',
  width: 432,
  cancelButtonProps: {
    type: 'primary',
    ghost: true,
  },
};

export const confirmDeclineInvitation = {
  title: 'Внимание',
  content:
    'Вы действительно хотите отклонить запрос на сотрудничество с водителем??',
  okText: 'Отклонить',
  cancelText: 'Отмена',
  className: 'confirm-red',
  okType: 'primary',
  width: 432,
  cancelButtonProps: {
    type: 'primary',
    ghost: true,
  },
};

export const confirmArchive = {
  title: 'Внимание',
  content:
    'Вы уверены, что хотите архивировать сотрудника? Вход в систему для него будет заблокирован.',
  okText: 'Архивировать',
  cancelText: 'Отмена',
  className: 'confirm-red',
  okType: 'danger',
  width: 432,
  cancelButtonProps: {
    style: { width: 176 },
    type: 'primary',
  },
  okButtonProps: {
    style: { width: 176 },
  },
};

export const confirmRestoreArchive = {
  title: 'Внимание',
  content:
    'Вы действительно хотите восстановить сотрудника? Ему снова станет доступен вход в систему.',
  okText: 'Восстановить',
  cancelText: 'Отмена',
  className: 'confirm-gray',
  okType: 'primary',
  width: 432,
  cancelButtonProps: {
    style: { width: 176 },
  },
  okButtonProps: {
    style: { width: 176 },
  },
};
